import { Input } from 'antd';
import { FormLabel } from 'components/UI/FormLabel';
import { Field, FieldProps, useFormikContext } from 'formik';
import { FC } from 'react';

interface Props {
  fieldName: string;
  placeholder?: string;
  type?: string;
  label: string;
}

export const FieldInput: FC<Props> = ({ fieldName, placeholder, type, label }) => {
  const { handleSubmit } = useFormikContext();

  const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Field name={fieldName} placeholder={placeholder}>
      {({
        field, // { name, value, onChange, onBlur }
        form: { setFieldTouched }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta
      }: FieldProps): JSX.Element => {
        return (
          <div>
            <FormLabel label={label} />
            <Input onKeyDown={handleEnter} onFocus={(): void => setFieldTouched(fieldName, false)} style={{ borderColor: meta.error && meta.touched ? '#dc3545' : undefined }} type={type} {...field} />
            <div className={meta.touched && meta.error ? 'field-error-show' : 'field-error-hide'}>{meta.error}</div>
          </div>
        );
      }}
    </Field>
  );
};
